export class DataCatalogDataset {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "catalogName",
            "baseName": "catalogName",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "datasetType",
            "baseName": "datasetType",
            "type": "DataCatalogDatasetType",
            "format": ""
        },
        {
            "name": "viewProperties",
            "baseName": "viewProperties",
            "type": "DataCatalogViewProperties",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "schema",
            "baseName": "schema",
            "type": "DataCatalogDatasetSchema",
            "format": ""
        },
        {
            "name": "semanticLayer",
            "baseName": "semanticLayer",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogDataset.attributeTypeMap;
    }
    constructor() {
    }
}
